module.exports = __webpack_public_path__ + "static/media/hu.f88c0a99.svg";